export const paymentMethods = [
	{
		type: 'card',
		region: ['eu', 'us', 'row', 'gb', 'au', 'ca'],
		isEnabled: true,
		period: [1, 12, 24],
		name: 'Credit Card',
		iconName: 'wizard/credit-card'
	},
	{
		type: 'sepa_debit',
		region: ['eu'],
		isEnabled: true,
		period: [1, 12, 24],
		name: 'Wire Transfer',
		iconName: 'wizard/sepa_debit'
	},
	{
		type: 'klarna',
		region: ['us'],
		isEnabled: true,
		period: [12, 24],
		name: 'Pay over time by Klarna',
		iconName: 'wizard/klarna'
	},
	{
		type: 'sofort',
		region: ['eu'],
		isEnabled: false,
		period: [12, 24],
		name: 'Sofort',
		allowedCountries: ['at', 'be', 'de', 'it', 'nl', 'es'],
		iconName: 'wizard/credit-card'
	}
]

export const filteredPaymentMethodsByRegionAndPeriod = (region, period) => {
	return paymentMethods.filter(item => item.isEnabled && item.region.includes(region) && item.period.includes(period))
}

export const convertFromCents = (amount) => {
	return amount / 100
}

export const calculateTaxesAmount = (taxPercentage, amount, quantity, subtotal) => {
	// subtotal - amount with applied discount
	const price = subtotal && (subtotal < amount * quantity) ? subtotal : amount * quantity

	return Math.round(taxPercentage / 100 * (price * 100)) / 100
}

export const getKeyByValue = (object, value) => {
	return Object.keys(object).find(key => object[key] === value)
}

export function getDiscountedItems (coupon, items) {
	// method for discount calculation by products, used for manual calculations
	const appliedItems = coupon.products ? items.filter(it => coupon.products.includes(it.productId)) : items
	const total = appliedItems.reduce((amount, item) => amount + (item.price * (item.qty || 1)), 0)

	let updatedItems = []

	if (coupon.amountOff) {
		updatedItems = appliedItems.map((item) => {
			const itemSubtotal = (item.price * (item.qty || 1))
			const k = itemSubtotal / total
			const subtotal = coupon.amountOff * k / 100

			return { ...item, subtotal: subtotal > 0 ? subtotal : 0 }
		})
	}

	if (coupon.percentOff) {
		updatedItems = appliedItems.map((item) => {
			return {
				...item,
				subtotal: (item.qty || 1) * item.price * (coupon.percentOff / 100)
			}
		})
	}

	return {
		updatedItems,
		ids: updatedItems.map(item => item.id)
	}
}

export const checkIfZeroPayment = (items, coupon, shippingCost) => {
	const itemsTotal = items.reduce((amount, item) => amount + (item.price * (item.qty || 1)), 0)

	if (coupon && coupon.percentOff === 100 && !coupon.products) {
		return true
	} else if (coupon && !coupon.products && ((coupon.amountOff / 100) >= (itemsTotal + shippingCost))) {
		return true
	} else if (coupon && coupon.products) {
		const appliedItems = coupon.products ? items.filter(it => coupon.products.includes(it.productId)) : items
		const total = appliedItems.reduce((amount, item) => amount + (item.price * (item.qty || 1)), 0)

		return total >= itemsTotal + shippingCost
	} else {
		return false
	}
}
